<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" ref="table">
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :rows="params"></Details>
    </template>
  </cTable>
</template>

<script>
import {
  getHwBill,
  resetHwAmount,
  getHwBillClient,
  saveHwBill,
  updateHwBill,
  delHwBill,
  getDetails,
  confirmBill,
  auditBill,
  appendCnbNo,
  getBillClients,
  exportAllBill,
  hwDoHedge,
  sync
} from "@/api/finance/hw_bill_hq";
import { waitOffBill } from "@/api/finance/codList";
import {
  getConfig,
  ConversionUsd,
  getUsdRate,
  getMonthUsers,
  createMonthUserBill,
  exportMonthBill,
  getOperator
} from "@/api/finance/bill";
import { client_hq } from "@/api/finance/shipment_hq";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getBank } from "@/api/finance/bank";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import Details from "./details";
import toPage from '@/base/common/topage'
import { getCurrency } from "@/api/finance/currency";
import invoice from "@/components/invoice";

export default {
  name: "hw_bill_hq",
  components: {
    cTable,
    Details,
    invoice
  },
  data() {
    let options = [
      { label: this.$t("month_t"), value: "MONTH" },
      { label: this.$t("half_moon"), value: "HALFMONTH" },
      { label: this.$t("week"), value: "WEEK" },
      { label: this.$t("day"), value: "DAY" }
    ];
    return {
      config: {
        isGetList: false
      },
      client_hq_list: [],
      hq_clients: [],
      methods: {
        list: data => {
          let params = JSON.parse(JSON.stringify(data));
          if (data.hq_client) {
            params.hq_client = this.client_hq_list.reduce((a, b) => {
              this.hq_clients.find(t => {
                if (t.value === b.uuid && t.label === b.account) {
                  a.push(b);
                  return true;
                }
              });
              return a;
            }, []);
          }
          return getHwBill(params);
        },
        sync,
        saveHwBill,
        getDetails,
        delHwBill,
        getHwBillClient,
        resetHwAmount,
        auditBill,
        confirmBill,
        getConfig,
        updateHwBill,
        getAllClient,
        appendCnbNo,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push({
            text: this.$t("total"),
            replace_currency: "CNY",
            total_amount: data.totalAmount
          });
        },
        ConversionUsd,
        createMonthUserBill,
        getUsdRate,
        getMonthUsers,
        exportMonthBill,
        exportAllBill,
        getOperator,
        getBillClients,
        getBank,
        waitOffBill,
        hwDoHedge
      },
      totalAmount: [],
      modals: {
        hedge: {
          methods: {
            ok({ row, close }) {
              let data = {
                hedge_bill_list: this.selectAll,
                bill_amount: row.final_amount_cny,
                bill_id: row.id,
                token: row.token,
                hedge_bill_amount: row.hedge_bill_amount
              };
              this.$page.handleRequestMethods("hwDoHedge", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            },
            checkTable({ row }) {
              let amount = 0;
              row.map(item => {
                amount += parseFloat(item.amount);
                return;
              });
              this.$refs["form"].formData.hedge_bill_amount = parseFloat(
                amount.toFixed(2)
              );
              this.$forceUpdate();
            }
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            formBind: {}
          },
          grid: [
            {
              name: this.$t("basic_information"),
              children: [
                {
                  client_name: 8,
                  final_amount_cny: 8,
                  hedge_bill_amount: 8
                }
              ]
            }
          ],
          fields: [
            {
              name: () => this.$t("clientName") + ":",
              key: "client_name"
            },
            {
              name: () =>
                this.$t("NotWrittenOff") + this.$t("reChAmount") + "(CNY):",
              key: "final_amount_cny",
              bind: {
                style: {
                  color: "red",
                  fontSize: "20px",
                  fontWeight: "bold"
                }
              }
            },
            {
              name: () => this.$t("selected") + this.$t("reChAmount") + ":",
              key: "hedge_bill_amount",
              bind: {
                style: {
                  color: "red",
                  fontSize: "20px",
                  fontWeight: "bold"
                }
              }
            }
          ],
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("bill_name"),
                align: "left",
                key: "name"
              },
              {
                name: () => this.$t("bill_number"),
                key: "bill_number",
                align: "left"
              },
              {
                name: () => this.$t("codTypes"),
                key: "b_type"
              },
              {
                name: () => this.$t("currencyCode"),
                key: "currency",
                width: 80
              },
              {
                name: () => this.$t("amount"),
                key: "amount"
              }
            ]
          }
        },
        append: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods("appendCnbNo", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_numbers: [
                {
                  required: true,
                  message: "Please Enter airway_number",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_numbers: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 10
              }
            }
          ]
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = { period: row.period };
              data.client_id = this.selectAll.map(item => item.client_id);
              this.$page.handleRequestMethods("saveHwBill", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              period: [
                {
                  required: true,
                  message: "Please select period",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ period: 24 }, { client: 24 }],
          fields: [
            {
              name: () => this.$t("period"),
              key: "period",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("period"),
              options: options,
              methods: {
                async "on-change"({ formData }) {
                  this.$page.getModal("add").list = [];
                  if (formData.period) {
                    let data = (
                      await this.$page.handleRequestMethods(
                        "getHwBillClient",
                        this.formData,
                        true,
                        true
                      )
                    ).payload;
                    this.$page.getModal("add").client = this.$page.getModal(
                      "add"
                    ).list = data;
                  }
                }
              }
            },
            {
              name: () => this.$t("clientName"),
              key: "client",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("clientName") + this.$t("search"),
              methods: {
                "on-search"({ formData }) {
                  let that = this.$page.getModal("add");
                  that.list = that.client.filter(
                    item =>
                      item.account
                        .toLowerCase()
                        .indexOf(formData.client.toLowerCase()) !== -1
                  );
                }
              },
              bind: {
                suffix: "ios-search",
                search: true
              }
            }
          ],
          table: {
            config: {
              height: 300
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("clientName"),
                align: "left",
                key: "account",
                minWidth: 100
              },
              {
                name: () => this.$t("period"),
                key: "billing_cycle",
                align: "center",
                minWidth: 100,
                methods: {
                  render() {
                    return options.find(
                      item =>
                        item.value ==
                        this.getModal("add").$refs["form"].formData.period
                    ).label;
                  }
                }
              },
              {
                name: () => this.$t("salesman"),
                key: "salesman_account",
                align: "left",
                minWidth: 100
              }
            ]
          }
        },
        update: {
          type: 'add',
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("updateHwBill", row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ],
              to_currency: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "Please Enter rate",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { name: 24 },
            { bill_currency: 12, bill_amount: 12 },
            { to_currency: 12, rate: 12 },
          ],
          fields: [
            {
              name: this.$t("bill1") + this.$t('currency_t'),
              key: "bill_currency",
              component: "Select",
              placeholder: () => this.$t('select') + this.$t("bill1") + this.$t('currency_t'),
              options: [],
              disabled: true,
              config: {
                label: "title",
                value: "code",
              },
            },
            {
              name: this.$t("toCurrency"),
              key: "to_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code",
              },
            },
            {
              name: () => this.$t("total_amount"),
              key: "bill_amount",
              component: "Input",
              disabled: true,
              placeholder: () => this.$t("enter") + this.$t("total_amount")
            },
            {
              name: () => this.$t('rate'),
              key: "rate",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0
            },

            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            }
          ]
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row))
              if (!data.invoice.is_open) delete data['invoice']
              this.$page.handleRequestMethods("auditBill", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              o_type: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ status: 24 }, { o_type: 24 }, { remarks: 24 },
          { invoice: 24 }
          ],
          fields: [
            {
              name: () => this.$tz("是否,开票"),
              key: 'invoice',
              render(h, p) {
                if (!p.row.invoice) p.row.invoice = { is_open: 0, amount: '' }
                return h(invoice, {
                  props: {
                    formData: p.row.invoice
                  },
                })
              }
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("refuse"), value: 0 },
                { label: this.$t("allow"), value: 1 }
              ],
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("type"),
              key: "o_type",
              component: "Radio",
              options: [
                { label: this.$t("onLine"), value: 1 },
                { label: this.$t("offLine"), value: 2 }
              ],
              bind: {
                border: true
              },
              default: 1,
              show({ row }) {
                return row.status == 1;
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              show({ row }) {
                return row.o_type == 2;
              }
            }
          ]
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500
            },
            modalContentBind: {
              style: {
                height: "700px"
              }
            }
          },
          footer: { show: () => false }
        }
      },
      footer: {
        show: () => true,
        render: h => {
          return h(
            "div",
            {
              class: "footer-content"
            },
            this.totalAmount.map(item => {
              return h(
                "div",
                {
                  class: "footer-content-item"
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title"
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  )
                ]
              );
            })
          );
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          // {
          //   key: "time_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: []
          // },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            options: []
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () =>
              this.$t("select") +
              this.$t("CollectionUser"),
            clearable: true,
            default: 1,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 }
            ],
          },
          {
            key: "hq_client",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("HQClient");
            },
            clearable: true,
            options: [],
            default: [],
            config: { label: "account", value: "uuid" },
            bind: {
              style: "width:200px",
              multiple: true,
              "max-tag-count": 1,
              "label-in-value": true
            },
            methods: {
              "on-change": data => {
                this.hq_clients = data._value;
              }
            }
          },
          {
            key: "operator_id",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: []
            // config: {
            //   label: "account",
            //   value: "id"
            // }
          },

          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: this.$t("export"),
              // type: "export",
              // fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary"
              },
              list: [
                {
                  name: this.$t("ListData"),
                  type: "export",
                  fnName: "export",
                  disabled() {
                    return !this.selectAll.length;
                  }
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
                // {
                //   name: "月账单",
                //   type: "monthBill",
                //   fnName: "monthBill",
                //   disabled() {
                //     return !this.selectAll.length;
                //   }
                //   // bind: {
                //   //   icon: "md-arrow-down",
                //   //   type: "primary"
                //   // }
                // },
                {
                  name: this.$t("summary") + this.$t("export"),
                  type: "allBill",
                  fnName: "allBill",
                  disabled() {
                    return !this.selectAll.length;
                  }
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                }
              ]
            },
            {
              name: () => this.$t("synchronous"),
              type: "sync",
              fnName: "sync",
              bind: {
                // icon: "md-checkmark",
                type: "primary"
              }
            }
            // {
            //   name: () => this.$t("writeOff"),
            //   type: "writeOff",
            //   fnName: "writeOff",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // }
          ],
          methods: {
            sync() {
              this.handleRequestMethods("sync").then(res => {
                this.getList();
              });
            },
            export() {
              this.exportExc();
            },
            allBill() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.handleRequestMethods(
                "exportAllBill",
                data,
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload, "_blank");
                // this.closeLoading();
              });
            },
            // monthBill() {
            //   let data = {
            //     id: this.selectAll.map(item => item.id)
            //   };
            //   this.openLoading();
            //   this.handleRequestMethods("exportMonthBill", data).then(res => {
            //     window.open(this.$globalUrl + res.payload);
            //     this.closeLoading();
            //   });
            // },
            add() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$t("add"));
              });
            }
            // writeOff() {
            //   this.getModal("writeOff").setTitle(this.$t("writeOff"));
            //   this.getModal("writeOff").type = "batchWriteOff";
            //   this.getModal("writeOff").open();
            // }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          align: "center",
          component: this.$hasPermission(568) || true ? "Button" : "span",
          minWidth: 190,
          copy: true,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              // if (!this.$hasPermission(568)) return;
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            }
          }
        },
        {
          name: () => this.$t("CollectionUser"),
          align: "center",
          key: "target_type_txt",
          minWidth: 100,
          bind: {
            style({ row }) {
              if (row.target_type === 2) {
                return { color: "red" };
              }
            }
          }
        },
        {
          name: () => this.$t("codNAme"),
          align: "center",
          key: "name",
          minWidth: 100,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("orderNums"),
          key: "total_votes",
          align: "center",
          minWidth: 80,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        // {
        //   name: () => this.$t("total_votes"),
        //   align: "center",
        //   key: "total_votes",
        //   width: 80
        // },
        // {
        //   name: () => this.$t("amount") + "(CNY)",
        //   key: "total_cny",
        //   align: "center",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("amount") + "(USD)",
        //   align: "center",
        //   key: "total_usd",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("rate") + "(USD-CNY)",
        //   align: "center",
        //   key: "usd_to_cny_rate",
        //   width: 130
        // },
        {
          name: () => this.$t('OriginalCurrency'),
          children: [
            {
              name: this.$t('currency_t'),
              align: "center",
              key: "bill_currency",
              width: 80,
            },
            {
              name: this.$t('total_amount'),
              align: "center",
              key: "bill_amount",
              width: 80,
            }
          ]
        },
        {
          name: () => this.$t('to'),
          children: [
            {
              name: this.$t('toCurrency'),
              align: "center",
              key: "to_bill_currency",
              width: 80,
            },
            {
              name: this.$t('rate'),
              align: "center",
              key: "to_bill_rate",
              width: 80,
            },
            {
              name: this.$t('total_amount'),
              align: "center",
              key: "to_bill_amount",
              width: 80,
            }
          ]
        },
        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "client_account",
          width: 100,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("ownership"),
          align: "center",
          key: "ownership_name",
          width: 100,
          methods: {
            render({ value }) {
              return value && value.title;
            }
          }
        },
        {
          name: () => this.$t("status_operator"),
          align: "center",
          key: "operator_name",
          width: 100,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("audit"),
          align: "center",
          key: "audit_account",
          width: 100,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          align: "center",
          key: "create_time",
          width: 170
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("audit_time"),
          key: "audit_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("paid_time"),
          key: "paid_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          align: "center",
          minWidth: 100,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        {
          name: () => this.$t("b2bClient") + this.$t("order_desc"),
          key: "client_remarks",
          align: "center",
          minWidth: 100,
          methods: {
            render({ row, field }) {
              return row.financeInfo[field.key];
            }
          }
        },
        // {
        //   name: () => this.$t("b2bClient") + this.$t("order_desc"),
        //   key: "client_remarks",
        //   align: "center",
        //   minWidth: 170
        // },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 300,
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo"),
              type: "append",
              fnName: "append",
              bind: {
                type: "warning"
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              }
              // id: 365
            },
            {
              name: () => this.$t("resAmount"),
              type: "resetAmount",
              fnName: "resetAmount",
              bind: {
                type: "error"
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              disabled({ row }) {
                return row.financeInfo.status == "WAIT_CONFIRM" ||
                  row.financeInfo.status == "DISAGREE"
                  ? false
                  : true;
              }
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "warning"
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              }
            },
            /* {
              name: () => this.$t("hedging"),
              type: "hedge",
              fnName: "hedge",
              bind: {
                type: "error"
              },
              disabled({ row }) {
                return row.financeInfo.status != "CONFIRMED";
              }
            }, */
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "warning"
              },
              disabled({ row }) {
                return row.financeInfo.status != "CONFIRMED";
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              }
            }
          ],
          methods: {
            hedge({ row }) {
              let data = {
                type: "HW",
                bill_id: row.id
              };
              this.handleRequestMethods("waitOffBill", data).then(res => {
                let data = res.payload.data;
                row.token = res.payload.token;
                row.hedge_bill_amount = 0;
                row.client_name = row.clientInfo && row.clientInfo.account;
                row.final_amount_cny = row.amount;
                this.getModal("hedge").open(row, function () {
                  this.setTitle(
                    row.bill_number + "(" + this.$t("hedging") + ")"
                  );
                  this.list = data;
                });
              });
            },
            resetAmount({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.openLoading();
                  this.handleRequestMethods("resetHwAmount", row.id).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            },

            append({ row }) {
              this.getModal("append").open({ id: row.id }, function () {
                this.setTitle(this.$t("addTo"));
              });
            },
            update({ row }) {
              this.getModal("update").open(
                {
                  name: row.financeInfo.name,
                  bill_currency: row.bill_currency,
                  bill_amount: row.bill_amount,
                  to_currency: row.to_currency,
                  rate: parseFloat(row.rate || 0),
                  id: row.id
                },
                function () {
                  this.setTitle(
                    this.$t("bill1") +
                    "(" +
                    row.bill_number +
                    ")" +
                    this.$t("update")
                  );
                }
              );
            },
            confirmOrder({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("confirmBill", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            writeOff({ row }) {
              let data = {
                check_amount_currency: "CNY",
                id: row.id,
                check_amount: row.amount
              };
              this.getModal("writeOff").open(data, function () {
                this.setTitle(
                  this.$t("bill1") +
                  "(" +
                  row.bill_number +
                  ")" +
                  this.$t("writeOff")
                );
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("delHwBill", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mixins: [toPage],
  async mounted() {
    let data = (await getConfig()).data.payload;
    let operator = (await getOperator()).data.payload;
    this.client_hq_list = (await client_hq()).data.payload;
    this.Currency = (await getCurrency()).data.payload.rows;
    this.modals.update.fields.forEach(t => {
      if (t.key === 'bill_currency') {
        t.options = this.Currency
      }
      if (t.key === 'to_currency') {
        t.options = this.Currency
      }
    })
    this.header.searchs.forEach(async item => {
      if (item.key === "status")
        item.options = Object.keys(data.status).map(item => ({
          value: item,
          label: data.status[item]
        }));
      if (item.key === "hq_client") item.options = this.client_hq_list;
      if (item.key === "operator_id") item.options = operator;
    });
  }
};
</script>
